import { render, staticRenderFns } from "./ApplicantBusinessConstitutiveDocument.vue?vue&type=template&id=09ca2b50&"
import script from "./ApplicantBusinessConstitutiveDocument.vue?vue&type=script&lang=js&"
export * from "./ApplicantBusinessConstitutiveDocument.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantBusinessConstitutiveDocument.vue?vue&type=style&index=0&id=09ca2b50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports